export interface Language {
  code: string;
  name: string;
  nativeName: string;
  flag: string;
  region?: string;
}

export const LANGUAGES: Language[] = [
  // Major European Languages
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇵🇹' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский', flag: '🇷🇺' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski', flag: '🇵🇱' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', flag: '🇳🇱' },
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska', flag: '🇸🇪' },
  { code: 'no', name: 'Norwegian', nativeName: 'Norsk', flag: '🇳🇴' },
  { code: 'da', name: 'Danish', nativeName: 'Dansk', flag: '🇩🇰' },
  { code: 'fi', name: 'Finnish', nativeName: 'Suomi', flag: '🇫🇮' },
  { code: 'cs', name: 'Czech', nativeName: 'Čeština', flag: '🇨🇿' },
  { code: 'hu', name: 'Hungarian', nativeName: 'Magyar', flag: '🇭🇺' },
  { code: 'ro', name: 'Romanian', nativeName: 'Română', flag: '🇷🇴' },
  { code: 'bg', name: 'Bulgarian', nativeName: 'Български', flag: '🇧🇬' },
  { code: 'hr', name: 'Croatian', nativeName: 'Hrvatski', flag: '🇭🇷' },
  { code: 'sk', name: 'Slovak', nativeName: 'Slovenčina', flag: '🇸🇰' },
  { code: 'sl', name: 'Slovenian', nativeName: 'Slovenščina', flag: '🇸🇮' },
  { code: 'et', name: 'Estonian', nativeName: 'Eesti', flag: '🇪🇪' },
  { code: 'lv', name: 'Latvian', nativeName: 'Latviešu', flag: '🇱🇻' },
  { code: 'lt', name: 'Lithuanian', nativeName: 'Lietuvių', flag: '🇱🇹' },
  { code: 'el', name: 'Greek', nativeName: 'Ελληνικά', flag: '🇬🇷' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', flag: '🇹🇷' },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Українська', flag: '🇺🇦' },
  { code: 'be', name: 'Belarusian', nativeName: 'Беларуская', flag: '🇧🇾' },
  { code: 'mk', name: 'Macedonian', nativeName: 'Македонски', flag: '🇲🇰' },
  { code: 'sq', name: 'Albanian', nativeName: 'Shqip', flag: '🇦🇱' },
  { code: 'sr', name: 'Serbian', nativeName: 'Српски', flag: '🇷🇸' },
  { code: 'bs', name: 'Bosnian', nativeName: 'Bosanski', flag: '🇧🇦' },
  { code: 'me', name: 'Montenegrin', nativeName: 'Crnogorski', flag: '🇲🇪' },

  // Asian Languages
  { code: 'zh', name: 'Chinese (Simplified)', nativeName: '中文 (简体)', flag: '🇨🇳' },
  { code: 'zh-tw', name: 'Chinese (Traditional)', nativeName: '中文 (繁體)', flag: '🇹🇼' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', flag: '🇰🇷' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা', flag: '🇧🇩' },
  { code: 'ur', name: 'Urdu', nativeName: 'اردو', flag: '🇵🇰' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', flag: '🇮🇳' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు', flag: '🇮🇳' },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം', flag: '🇮🇳' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ', flag: '🇮🇳' },
  { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી', flag: '🇮🇳' },
  { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ', flag: '🇮🇳' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย', flag: '🇹🇭' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'ms', name: 'Malay', nativeName: 'Bahasa Melayu', flag: '🇲🇾' },
  { code: 'tl', name: 'Filipino', nativeName: 'Filipino', flag: '🇵🇭' },
  { code: 'my', name: 'Burmese', nativeName: 'မြန်မာ', flag: '🇲🇲' },
  { code: 'km', name: 'Khmer', nativeName: 'ខ្មែរ', flag: '🇰🇭' },
  { code: 'lo', name: 'Lao', nativeName: 'ລາວ', flag: '🇱🇦' },

  // Middle Eastern & African Languages
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦' },
  { code: 'fa', name: 'Persian', nativeName: 'فارسی', flag: '🇮🇷' },
  { code: 'he', name: 'Hebrew', nativeName: 'עברית', flag: '🇮🇱' },
  { code: 'am', name: 'Amharic', nativeName: 'አማርኛ', flag: '🇪🇹' },
  { code: 'sw', name: 'Swahili', nativeName: 'Kiswahili', flag: '🇰🇪' },
  { code: 'ha', name: 'Hausa', nativeName: 'Hausa', flag: '🇳🇬' },
  { code: 'yo', name: 'Yoruba', nativeName: 'Yorùbá', flag: '🇳🇬' },
  { code: 'ig', name: 'Igbo', nativeName: 'Igbo', flag: '🇳🇬' },
  { code: 'zu', name: 'Zulu', nativeName: 'IsiZulu', flag: '🇿🇦' },
  { code: 'af', name: 'Afrikaans', nativeName: 'Afrikaans', flag: '🇿🇦' },
  { code: 'xh', name: 'Xhosa', nativeName: 'IsiXhosa', flag: '🇿🇦' },

  // Americas
  { code: 'pt-br', name: 'Portuguese (Brazil)', nativeName: 'Português (Brasil)', flag: '🇧🇷' },
  { code: 'es-mx', name: 'Spanish (Mexico)', nativeName: 'Español (México)', flag: '🇲🇽' },
  { code: 'es-ar', name: 'Spanish (Argentina)', nativeName: 'Español (Argentina)', flag: '🇦🇷' },
  { code: 'fr-ca', name: 'French (Canada)', nativeName: 'Français (Canada)', flag: '🇨🇦' },

  // Other Important Languages
  { code: 'ca', name: 'Catalan', nativeName: 'Català', flag: '🇪🇸' },
  { code: 'eu', name: 'Basque', nativeName: 'Euskera', flag: '🇪🇸' },
  { code: 'gl', name: 'Galician', nativeName: 'Galego', flag: '🇪🇸' },
  { code: 'cy', name: 'Welsh', nativeName: 'Cymraeg', flag: '🇬🇧' },
  { code: 'ga', name: 'Irish', nativeName: 'Gaeilge', flag: '🇮🇪' },
  { code: 'gd', name: 'Scottish Gaelic', nativeName: 'Gàidhlig', flag: '🇬🇧' },
  { code: 'mt', name: 'Maltese', nativeName: 'Malti', flag: '🇲🇹' },
  { code: 'is', name: 'Icelandic', nativeName: 'Íslenska', flag: '🇮🇸' },
  { code: 'fo', name: 'Faroese', nativeName: 'Føroyskt', flag: '🇫🇴' },
  { code: 'lb', name: 'Luxembourgish', nativeName: 'Lëtzebuergesch', flag: '🇱🇺' },
];

// Helper functions
export const getLanguageByCode = (code: string): Language | undefined => {
  return LANGUAGES.find(lang => lang.code === code);
};

export const getLanguageName = (code: string): string => {
  const language = getLanguageByCode(code);
  return language ? language.name : code;
};

export const getLanguageNativeName = (code: string): string => {
  const language = getLanguageByCode(code);
  return language ? language.nativeName : code;
};

export const getLanguageFlag = (code: string): string => {
  const language = getLanguageByCode(code);
  return language ? language.flag : '🌐';
};

// For backward compatibility with existing components
export const LANGUAGES_SIMPLE = LANGUAGES.map(lang => ({
  value: lang.code,
  label: lang.name,
  flag: lang.flag,
  nativeName: lang.nativeName
}));

// For components that need just code and name
export const LANGUAGES_BASIC = LANGUAGES.map(lang => ({
  code: lang.code,
  name: lang.name
}));

/**
 * Maps ISO country codes to language codes
 * This is used to set default language based on user's country from onboarding
 */
export const COUNTRY_TO_LANGUAGE: Record<string, string> = {
  // English-speaking countries
  'US': 'en', // United States
  'GB': 'en', // United Kingdom
  'CA': 'en', // Canada
  'AU': 'en', // Australia
  'NZ': 'en', // New Zealand
  'IE': 'en', // Ireland
  'ZA': 'en', // South Africa
  
  // Spanish-speaking countries
  'ES': 'es', // Spain
  'MX': 'es', // Mexico
  'AR': 'es', // Argentina
  'CO': 'es', // Colombia
  'CL': 'es', // Chile
  'PE': 'es', // Peru
  'VE': 'es', // Venezuela
  'EC': 'es', // Ecuador
  'GT': 'es', // Guatemala
  'CU': 'es', // Cuba
  'BO': 'es', // Bolivia
  'DO': 'es', // Dominican Republic
  'HN': 'es', // Honduras
  'PY': 'es', // Paraguay
  'SV': 'es', // El Salvador
  'NI': 'es', // Nicaragua
  'CR': 'es', // Costa Rica
  'PA': 'es', // Panama
  'UY': 'es', // Uruguay
  
  // French-speaking countries
  'FR': 'fr', // France
  'BE': 'fr', // Belgium
  'CH': 'fr', // Switzerland (French-speaking)
  'MC': 'fr', // Monaco
  'LU': 'fr', // Luxembourg
  
  // German-speaking countries
  'DE': 'de', // Germany
  'AT': 'de', // Austria
  'LI': 'de', // Liechtenstein
  
  // Portuguese-speaking countries
  'PT': 'pt', // Portugal
  'BR': 'pt-br', // Brazil
  'AO': 'pt', // Angola
  'MZ': 'pt', // Mozambique
  
  // Italian-speaking countries
  'IT': 'it', // Italy
  'SM': 'it', // San Marino
  'VA': 'it', // Vatican City
  
  // Dutch-speaking countries
  'NL': 'nl', // Netherlands
  
  // Scandinavian countries
  'SE': 'sv', // Sweden
  'NO': 'no', // Norway
  'DK': 'da', // Denmark
  'FI': 'fi', // Finland
  'IS': 'is', // Iceland
  
  // Baltic countries
  'LT': 'lt', // Lithuania
  'LV': 'lv', // Latvia
  'EE': 'et', // Estonia
  
  // Eastern European countries
  'PL': 'pl', // Poland
  'CZ': 'cs', // Czech Republic
  'SK': 'sk', // Slovakia
  'HU': 'hu', // Hungary
  'RO': 'ro', // Romania
  'BG': 'bg', // Bulgaria
  'HR': 'hr', // Croatia
  'SI': 'sl', // Slovenia
  'RS': 'sr', // Serbia
  'BA': 'bs', // Bosnia and Herzegovina
  'ME': 'me', // Montenegro
  'MK': 'mk', // North Macedonia
  'AL': 'sq', // Albania
  
  // Russian-speaking countries
  'RU': 'ru', // Russia
  'BY': 'be', // Belarus
  'KZ': 'ru', // Kazakhstan
  'UA': 'uk', // Ukraine
  
  // Greek-speaking countries
  'GR': 'el', // Greece
  'CY': 'el', // Cyprus
  
  // Turkish-speaking countries
  'TR': 'tr', // Turkey
  
  // Asian countries
  'CN': 'zh', // China
  'TW': 'zh-tw', // Taiwan
  'HK': 'zh', // Hong Kong
  'SG': 'en', // Singapore (English)
  'JP': 'ja', // Japan
  'KR': 'ko', // South Korea
  'IN': 'hi', // India (Hindi)
  'BD': 'bn', // Bangladesh
  'PK': 'ur', // Pakistan
  'TH': 'th', // Thailand
  'VN': 'vi', // Vietnam
  'ID': 'id', // Indonesia
  'MY': 'ms', // Malaysia
  'PH': 'tl', // Philippines
  
  // Middle Eastern countries
  'SA': 'ar', // Saudi Arabia
  'AE': 'ar', // United Arab Emirates
  'EG': 'ar', // Egypt
  'IQ': 'ar', // Iraq
  'JO': 'ar', // Jordan
  'LB': 'ar', // Lebanon
  'SY': 'ar', // Syria
  'YE': 'ar', // Yemen
  'IR': 'fa', // Iran
  'IL': 'he', // Israel
};

/**
 * Gets the default language code for a given country code
 * @param countryCode ISO 2-letter country code (e.g., 'US', 'LT', 'GB')
 * @returns Language code (e.g., 'en', 'lt', 'es') or 'en' as fallback
 */
export function getLanguageFromCountry(countryCode: string | null | undefined): string {
  if (!countryCode) return 'en';
  
  const language = COUNTRY_TO_LANGUAGE[countryCode.toUpperCase()];
  return language || 'en'; // Default to English if country not found
}
